import React from 'react';

const NotFound = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h2>404 - Page Not Found</h2>
      <p>The page you're looking for doesn't exist.</p>
    </div>
  );
};

export default NotFound;
